/* eslint no-param-reassign: "off" */
import date from './tools/date.js';
import string from './tools/string.js';
import time from './tools/time.js';

export default {
  install(Vue, options) {
    Vue.prototype.$tools = {
      date,
      string,
      time,
      money(value) {
        if (!value) return null;
        const currency = options.store.state.data.settings.currency_sign || '₽';
        const decimals = !options.store.state.data.settings.hide_money_decimals;
        const val = Vue.prototype.$tools.string.numberFormat(value, decimals);
        return `${val} ${currency}`;
      },
      weight(value) {
        if (!value) return 0;
        let rate = 1e6;
        let units = 'weight-t';
        if (value < 1000) {
          rate = 1;
          units = 'weight-g';
        } else if (value < 1e6) {
          rate = 1e3;
          units = 'weight-kg';
        }
        const valueFormatted = Vue.prototype.$tools.string.numberFormat(value / rate);
        const unitsFormatted = Vue.prototype.$dictionary.get(units);
        return `${valueFormatted} ${unitsFormatted}`;
      },
    };
  },
};
